export const AdmiraltyStationMapInformation = {
  venue: "AdmiraltyStation",
  venueId: "20a3c69e-cac6-4409-b162-33f988b6b549",
  i18nVenue: "venue_admiralty_station",
  venueName: "Admiralty Station",
  venueName_zh: "Admiralty Station",
  avatar: "https://assets.deepworldmodel.ai/navigation/avatar/tchai_20260805_2124.glb",
  avatarIsFloating : false,
  floorAlignment: [
    {
      lcMapId: "675175ab-991d-40fe-a34a-01736847a1d7",
      id: "5af5c7ac-0c7d-4806-8678-0ce75585d407",
      ordinal: -1,
      name: "L1",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m5-1752094606911PATOZU.png",
      pixInMeter: 6.0225752732853985,
      center: { lat: 22.278455726183378, lng: 114.16627234226878 },
      angle: 311.7177605430511,
      scale: 166.04266070245396,
      corners: {
        tl: { lat: 22.278239006573557, lng: 114.16218947681222 },
        tr: { lat: 22.282233815270082, lng: 114.16603818232328 },
        br: { lat: 22.278672344063242, lng: 114.17035520772535 },
        bl: { lat: 22.274677637096673, lng: 114.16650647691166 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 595.0942638394572, height: 595.0942638811335 },
    },
    {
      lcMapId: "181e99c2-859b-4b9a-800b-4c91b1644db6",
      id: "2e85b096-32dd-429d-89f8-bb9fbf4e1bab",
      ordinal: -2,
      name: "L2",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m4-1752094207650VOKEFI.png",
      pixInMeter: 5.997975287201646,
      center: { lat: 22.2784536463196, lng: 114.16627456316847 },
      angle: 310.48981030483844,
      scale: 166.72376092021523,
      corners: {
        tl: { lat: 22.278154790440553, lng: 114.16218093229168 },
        tr: { lat: 22.28224169726942, lng: 114.1659516363568 },
        br: { lat: 22.278752400231006, lng: 114.17036819404527 },
        bl: { lat: 22.274665595369783, lng: 114.16659745499297 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 597.5349726072393, height: 597.5349726888278 },
    },
    {
      lcMapId: "3da6ef26-e1d0-49f8-bbc8-26f8e420fcbd",
      id: "81656da7-4c1d-4b42-8537-39d2438fc075",
      ordinal: -3,
      name: "L3",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m3-1752093610800JUCOBE.png",
      pixInMeter: 5.995262172027151,
      center: { lat: 22.27846227978535, lng: 114.1662630702222 },
      angle: 311.51141736048356,
      scale: 166.79913191355692,
      corners: {
        tl: { lat: 22.27823090575668, lng: 114.16216247762524 },
        tr: { lat: 22.282256772545008, lng: 114.16601307322256 },
        br: { lat: 22.278693551241364, lng: 114.17036366281916 },
        bl: { lat: 22.274667787025695, lng: 114.166513040089 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 597.8053829678123, height: 597.8053830985656 },
    },
    {
      lcMapId: "2d48383d-1580-4de6-9e8c-bc3935d8f4fa",
      id: "972cf23f-614d-4aee-8777-6c75aa8e56c9",
      ordinal: -4,
      name: "L4",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m2-1752092648201BEJUFI.png",
      pixInMeter: 6.030896614532297,
      center: { lat: 22.27845613581104, lng: 114.16627856608824 },
      angle: 310.5289573577781,
      scale: 165.81364799461244,
      corners: {
        tl: { lat: 22.278161485714882, lng: 114.16220706288887 },
        tr: { lat: 22.282223710795492, lng: 114.1659601840833 },
        br: { lat: 22.278750685027767, lng: 114.17035006928761 },
        bl: { lat: 22.27468856082659, lng: 114.1665969137847 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 594.2731616957274, height: 594.2731617827955 },
    },
    {
      lcMapId: "11a00d78-a549-4324-96c3-23032cba54dd",
      id: "18c6f342-8f87-4139-9f8b-d4b438db5366",
      ordinal: -5,
      name: "L5",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m1-1752092119446DOWOGU.png",
      pixInMeter: 6.015267432975162,
      center: { lat: 22.27845714083609, lng: 114.16626647548645 },
      angle: 311.1333518973379,
      scale: 166.2444283076436,
      corners: {
        tl: { lat: 22.27820158698681, lng: 114.1621812535721 },
        tr: { lat: 22.282237410438373, lng: 114.16599034627964 },
        br: { lat: 22.278712592966798, lng: 114.1703516974008 },
        bl: { lat: 22.274676871233808, lng: 114.16654257483862 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 595.8172332611773, height: 595.8172332783423 },
    },
    {
      lcMapId: "b68ef9e9-df4d-4861-9eb5-606854aa908c",
      id: "9d28be16-1ceb-4c47-93bd-b9121a5102b3",
      ordinal: -6,
      name: "L6",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m0-1752088202131WEDOVU.png",
      pixInMeter: 5.988426771112608,
      center: { lat: 22.278452835419227, lng: 114.16627241357378 },
      angle: 310.7323433454381,
      scale: 166.98958299929689,
      corners: {
        tl: { lat: 22.278169565986477, lng: 114.16217092312252 },
        tr: { lat: 22.282248159266743, lng: 114.16596633168956 },
        br: { lat: 22.278736002425298, lng: 114.17037390402503 },
        bl: { lat: 22.27465751157171, lng: 114.16657846223411 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 598.4877391340495, height: 598.4877390947761 },
    },
  ],
  modelConfig: {
    folderPath: "venue/admiralty_station/",
    defaultPosition: [-1910, 12, -1311],
    defaultTarget: [-1907.67, 12, -1306.57],
    defaultFloorIndex: -1,
    defaultLcMapId: "675175ab-991d-40fe-a34a-01736847a1d7",
    topAltitude: 600,
    downSpeed: 200,
    scaleFactor: 9.03382295643,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "floorLod",
    },
    floor: [
      {
        lcMapId: "675175ab-991d-40fe-a34a-01736847a1d7",
        gisLevelId: "5af5c7ac-0c7d-4806-8678-0ce75585d407",
        index: -1,
        name: "L1",
        shortName: "L1",
        topViewModel: "l1/L1_topView_20260714_1100_16tiles.glb",
        yAxis: 0,
        altitude: 14,
        defaultPosition: [-1910, 14, -1311],
        defaultTarget: [-1907.67, 14, -1306.57],
        meshGround: "l1/mesh_ground/L1_mesh_ground_20260730_2300.glb",
        meshObstacle: "l1/mesh_obstacle/L1_mesh_obstacle_20260730_2300.glb",
        annotation: "l1/annotation/L1-annotations_20260730_1600.json",
        lod: "l1/L1_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["675175ab-991d-40fe-a34a-01736847a1d7"],
      },
      {
        lcMapId: "181e99c2-859b-4b9a-800b-4c91b1644db6",
        gisLevelId: "2e85b096-32dd-429d-89f8-bb9fbf4e1bab",
        index: -2,
        name: "L2",
        shortName: "L2",
        topViewModel: "l2/L2_topView_20260714_1100_16tiles.glb",
        yAxis: -50,
        altitude: -38,
        defaultPosition: [-1963.07, -38, -1423.12],
        defaultTarget: [-1960.88, -38, -1418.62],
        meshGround: "l2/mesh_ground/L2_mesh_ground_20260730_2300.glb",
        meshObstacle: "l2/mesh_obstacle/L2_mesh_obstacle_20260730_2300.glb",
        annotation: "l2/annotation/L2-annotations_20260730_1600.json",
        lod: "l2/L2_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["181e99c2-859b-4b9a-800b-4c91b1644db6"],
      },
      {
        lcMapId: "3da6ef26-e1d0-49f8-bbc8-26f8e420fcbd",
        gisLevelId: "81656da7-4c1d-4b42-8537-39d2438fc075",
        index: -3,
        name: "L3",
        shortName: "L3",
        topViewModel: "l3/L3_topView_20260714_1100_16tiles.glb",
        yAxis: -100,
        altitude: -85,
        defaultPosition: [-1933.59, -85, -1359.45],
        defaultTarget: [-1935.95, -85, -1363.86],
        meshGround: "l3/mesh_ground/L3_mesh_ground_20260730_2300.glb",
        meshObstacle: "l3/mesh_obstacle/L3_mesh_obstacle_20260730_2300.glb",
        annotation: "l3/annotation/L3-annotations_20260730_1600.json",
        lod: "l3/L3_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["3da6ef26-e1d0-49f8-bbc8-26f8e420fcbd"],
      },
      {
        lcMapId: "2d48383d-1580-4de6-9e8c-bc3935d8f4fa",
        gisLevelId: "972cf23f-614d-4aee-8777-6c75aa8e56c9",
        index: -4,
        name: "L4",
        shortName: "L4",
        topViewModel: "l4/L4_topView_20260714_1100_16tiles.glb",
        yAxis: -150,
        altitude: -139,
        defaultPosition: [-2093.49, -139, -1712.85],
        defaultTarget: [-2088.9, -139, -1710.85],
        meshGround: "l4/mesh_ground/L4_mesh_ground_20260730_2300.glb",
        meshObstacle: "l4/mesh_obstacle/L4_mesh_obstacle_20260730_2300.glb",
        annotation: "l4/annotation/L4-annotations_20260730_1600.json",
        lod: "l4/L4_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["2d48383d-1580-4de6-9e8c-bc3935d8f4fa"],
      },
      {
        lcMapId: "11a00d78-a549-4324-96c3-23032cba54dd",
        gisLevelId: "18c6f342-8f87-4139-9f8b-d4b438db5366",
        index: -5,
        name: "L5",
        shortName: "L5",
        topViewModel: "l5/L5_topView_20260714_1100_16tiles.glb",
        yAxis: -200,
        altitude: -186,
        defaultPosition: [-2178.62, -186, -1700.74],
        defaultTarget: [-2173.62, -186, -1700.74],
        meshGround: "l5/mesh_ground/L5_mesh_ground_20260730_2300.glb",
        meshObstacle: "l5/mesh_obstacle/L5_mesh_obstacle_20260730_2300.glb",
        annotation: "l5/annotation/L5-annotations_20260730_1600.json",
        lod: "l5/L5_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["11a00d78-a549-4324-96c3-23032cba54dd"],
      },
      {
        lcMapId: "b68ef9e9-df4d-4861-9eb5-606854aa908c",
        gisLevelId: "9d28be16-1ceb-4c47-93bd-b9121a5102b3",
        index: -6,
        name: "L6",
        shortName: "L6",
        topViewModel: "l6/L6_topView_20260714_1100_16tiles.glb",
        yAxis: -250,
        altitude: -238,
        defaultPosition: [-1493.69, -238, -1667.68],
        defaultTarget: [-1498.69, -238, -1667.71],
        meshGround: "l6/mesh_ground/L6_mesh_ground_20260730_2300.glb",
        meshObstacle: "l6/mesh_obstacle/L6_mesh_obstacle_20260730_2300.glb",
        annotation: "l6/annotation/L6-annotations_20260730_1600.json",
        lod: "l6/L6_v10_100_20_1_c1024_x32_h0_st_3_1_6/lod-meta.json",
        displayLod: ["b68ef9e9-df4d-4861-9eb5-606854aa908c"],
      },
    ],
  },
};
